import React, { useContext } from "react";
import { Box, IconButton, Menu, MenuItem } from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings";
import useEnv from "../hooks/env";
import CookieService from "../api/services/common/CookieService";
import { SpecialContentContext } from "../contexts/SpecialContentContext";
import ConfirmationDialogContext from "../components/Dialog/ConfirmationDialog/ConfirmationDialogContext";
import ErrorSnackbarContext from "../contexts/ErrorSnackbarContext";
import ReusedTestSeriesApi from "../api/services/ReusedTestSeriesApi";

function DeveloperMenu() {
  const { api, oidc } = useEnv();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { updateXmasSpecialDialogOpen } = useContext(SpecialContentContext);
  const { showConfirmationDialog } = useContext(ConfirmationDialogContext);
  const { handleHttpError, handleDialogNegativeCallback } = useContext(ErrorSnackbarContext);
  const reusedTestSeriesApi = new ReusedTestSeriesApi(api);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton onClick={handleClick}>
        <SettingsIcon />
      </IconButton>
      <Menu style={{ zIndex: 999999 }} anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            const account = sessionStorage.getItem(`msal.${oidc.clientId}.active-account`);
            const authorityId = oidc.authority.substr(34, 36);
            if (account) {
              const refreshTokenKey = `${account}.${authorityId}-login.windows.net-refreshtoken-${oidc.clientId}--`;
              const refreshToken = sessionStorage.getItem(refreshTokenKey);
              const parsedToken = JSON.parse(refreshToken || "{}");
              parsedToken.secret = (parsedToken.secret || "1").replaceAll(/\d/g, "x");
              sessionStorage.setItem(refreshTokenKey, JSON.stringify(parsedToken));
            }
            handleClose();
          }}
        >
          Invalidate Refresh Token
        </MenuItem>
        <MenuItem
          onClick={() => {
            const account = sessionStorage.getItem(`msal.${oidc.clientId}.active-account`);
            const authorityId = oidc.authority.substr(34, 36);
            if (account) {
              const idTokenKey = `${account}.${authorityId}-login.windows.net-idtoken-${oidc.clientId}-${authorityId}-`;
              const idToken = sessionStorage.getItem(idTokenKey);
              const parsedToken = JSON.parse(idToken || "{}");
              parsedToken.secret = (parsedToken.secret || "1").replaceAll(/\d/g, "x");
              sessionStorage.setItem(idTokenKey, JSON.stringify(parsedToken));
            }
            handleClose();
          }}
        >
          Invalidate ID Token
        </MenuItem>
        <MenuItem
          onClick={() => {
            new CookieService().setCookie("UEQ-ID", "", 0);
            handleClose();
          }}
        >
          Clear Popup Cookie
        </MenuItem>
        <MenuItem
          onClick={() => {
            updateXmasSpecialDialogOpen(true);
            handleClose();
          }}
        >
          Display X-Mas Special
        </MenuItem>
        <MenuItem
          onClick={() => {
            const requestId = (window as never as { _dev?: { requestId: string } })._dev?.requestId;
            if (!requestId) {
              showConfirmationDialog({
                text: `No test request ID found in 'window._dev.requestId'.`,
              }).catch(handleDialogNegativeCallback);
              handleClose();
              return;
            }
            const testCaseId = (window as never as { _dev?: { testCaseId: number } })._dev?.testCaseId;
            if (!testCaseId) {
              showConfirmationDialog({
                text: `No test case ID found in 'window._dev.testCaseId'.`,
              }).catch(handleDialogNegativeCallback);
              handleClose();
              return;
            }
            showConfirmationDialog({
              text: `Attach test case ${testCaseId} to ${requestId}`,
            })
              .then(() => {
                reusedTestSeriesApi.addReusedTestSeries(requestId, [testCaseId]).catch(handleHttpError);
              })
              .catch(handleDialogNegativeCallback);
            handleClose();
          }}
        >
          Reuse Historical Data
        </MenuItem>
      </Menu>
    </div>
  );
}

function DeveloperMenuWrapper() {
  const { environment } = useEnv();
  if (environment === "minikube") {
    return (
      <Box position="fixed" top={0} right={0} style={{ zIndex: 999999 }}>
        <DeveloperMenu />
      </Box>
    );
  }
  return null;
}

export default DeveloperMenuWrapper;
